var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "question-list-answers" },
    _vm._l(_vm.questionList, function(question, index) {
      return _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !_vm.questionSearchMatcher ||
                _vm.questionSearchMatcher(question),
              expression:
                "!questionSearchMatcher || questionSearchMatcher(question)"
            }
          ],
          key: question._id,
          staticClass: "question-item answer",
          attrs: { "no-gutters": "" }
        },
        [
          _vm.isProjectOwner
            ? _c("QuestionAnswerItemOwner", {
                attrs: {
                  question: question,
                  "question-number": index + 1,
                  "project-in-review": _vm.projectInReview,
                  visible: _vm.visible,
                  "toggle-key": _vm.toggleKey
                }
              })
            : _c("QuestionAnswerItemParticipant", {
                attrs: {
                  question: question,
                  "question-number": index + 1,
                  "project-in-review": _vm.projectInReview,
                  visible: _vm.visible,
                  "toggle-key": _vm.toggleKey
                }
              })
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }